import { Box, Text, TooltipRenderer } from 'braid-design-system';
import type { ReactNode } from 'react';

interface TooltipFieldProps {
  children: ReactNode;
  name: string;
}

export const TooltipField = ({ children, name }: TooltipFieldProps) => (
  <TooltipRenderer
    id={`${name}Tooltip`}
    tooltip={<Text size="small">{name}</Text>}
  >
    {({ triggerProps }) => (
      <Box {...triggerProps} component="span" cursor="pointer">
        {children}
      </Box>
    )}
  </TooltipRenderer>
);
